var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.506,
    height: 92.26,
    viewBox: "0 0 74.506 92.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42963",
    "data-name": "Path 42963",
    d: "M104.871,82.62l-4.242,40.969a12.318,12.318,0,0,1-12.252,11.054H67.748A12.324,12.324,0,0,1,55.49,123.589L51.26,82.7",
    transform: "translate(-42.812 -44.383)",
    fill: "none",
    stroke: "#6f2f87",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42964",
    "data-name": "Path 42964",
    d: "M47.955,41.612A12.324,12.324,0,0,1,60.183,28h33.06A12.324,12.324,0,0,1,105.5,41.588",
    transform: "translate(-41.46 -22.488)",
    fill: "none",
    stroke: "#6f2f87",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x2: 70.506,
    transform: "translate(0 28.543)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 2.025,
    y2: 15.398,
    transform: "translate(23.684 56.277)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x1: 2.025,
    y2: 15.398,
    transform: "translate(44.24 56.277)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y2: 15.398,
    transform: "translate(35.253 56.277)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 4.176,
    cy: 4.176,
    r: 4.176,
    transform: "translate(31.077 0)",
    fill: "#6f2f87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.43c4415041f64e16c8ed72477ae84d85.svg";
export { ForwardRef as ReactComponent };